import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function PressureGaugeSVG({ value, config = {}, width = 60, height = 60 }) {
    const v = parseFloat(value ?? 0);
    const min = parseFloat(config.min_value ?? 0);
    const max = parseFloat(config.max_value ?? 10);
    const pct = Math.min(1, Math.max(0, (v - min) / (max - min || 1)));
    const cx = width / 2, cy = height / 2;
    const r = Math.min(width, height) / 2 - 5;
    // Semicircle arc: 210° to -30° (ISA gauge style), 240° sweep
    const startAngle = 210, sweep = 240;
    const toRad = d => d * Math.PI / 180;
    const arcX = (a) => cx + r * Math.cos(toRad(a));
    const arcY = (a) => cy + r * Math.sin(toRad(a));
    const needleAngle = startAngle + sweep * pct;
    const needleLen = r * 0.75;
    const nRad = toRad(needleAngle);
    const color = v > (config.high_threshold ?? max * 0.8) ? '#EF4444' : '#F59E0B';

    // Build arc path
    const arcStart = { x: arcX(startAngle), y: arcY(startAngle) };
    const arcEnd = { x: arcX(startAngle - sweep), y: arcY(startAngle - sweep) };

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Background circle */}
            <circle cx={cx} cy={cy} r={r} fill="#1E293B" stroke="#475569" strokeWidth={2} />
            {/* Arc track */}
            <path
                d={`M ${arcStart.x},${arcStart.y} A ${r},${r} 0 1 0 ${arcEnd.x},${arcEnd.y}`}
                fill="none" stroke="#334155" strokeWidth={4} strokeLinecap="round"
            />
            {/* Needle */}
            <line
                x1={cx} y1={cy}
                x2={cx + Math.cos(nRad) * needleLen}
                y2={cy + Math.sin(nRad) * needleLen}
                stroke={color} strokeWidth={2} strokeLinecap="round"
            />
            <circle cx={cx} cy={cy} r={4} fill={color} />
            {/* Value */}
            <text x={cx} y={cy + r * 0.55} textAnchor="middle" fill="#F1F5F9" fontSize={9} fontFamily="monospace">
                {isNaN(v) ? '--' : `${v.toFixed(1)}${config.unit || ' bar'}`}
            </text>
        </svg>
    );
}

export default function PressureGaugeNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <PressureGaugeSVG value={data?.liveValue} config={data?.config} width={data?.width || 60} height={data?.height || 60} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
